var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrinningFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27Z",
    fill: "#FFC942"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C11.4 15 11 14.6 11 14V13C11 12.4 11.4 12 12 12C12.6 12 13 12.4 13 13V14C13 14.6 12.6 15 12 15Z",
    fill: "#2D2C2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15C19.4 15 19 14.6 19 14V13C19 12.4 19.4 12 20 12C20.6 12 21 12.4 21 13V14C21 14.6 20.6 15 20 15Z",
    fill: "#2D2C2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18C21 20.8 18.8 23 16 23C13.2 23 11 20.8 11 18H21Z",
    fill: "#2D2C2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 20C14.7002 20 13.5002 20.9 13.2002 22.1C14.0002 22.7 14.9002 23 16.0002 23C17.1002 23 18.0002 22.7 18.8002 22.1C18.5002 20.9 17.3002 20 16.0002 20Z",
    fill: "#FF3F4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrinningFace);
export default __webpack_public_path__ + "static/media/grinning_face.39bda74d8cd216b0a25853f1ec33ad01.svg";
export { ForwardRef as ReactComponent };